export const DRAW_DOWN_SIGN_DOCUMENTS_DATA =
    'page/DRAW_DOWN_SIGN_DOCUMENTS [done]';

export const SIGN_DOCUMENT_ACTION = 'page/SIGN_DOCUMENT_ACTION';
export const SIGN_DOCUMENT_DROP_AGREE = 'page/SIGN_DOCUMENT_DROP_AGREE';
export const SIGN_DOCUMENT_AGREE_PENDING = 'page/SIGN_DOCUMENT_AGREE_PENDING';
export const SIGN_DOCUMENT_AGREE_DONE = 'page/SIGN_DOCUMENT_AGREE_DONE';
export const SIGN_DOCUMENT_AGREE_ERROR = 'page/SIGN_DOCUMENT_AGREE_ERROR';
export const SIGN_DOCUMENT_LOAD_DOCUMENT_CONTENT =
    'page/SIGN_DOCUMENT_SIGNING_DOCUMENT [loading]';
export const SIGN_DOCUMENT_SHOW_DOCUMENT_CONTENT =
    'page/SIGN_DOCUMENT_DOCUMENT_CONTENT [done]';
export const SIGN_DOCUMENT_SHOW_DOCUMENT_ERROR =
    'page/SIGN_DOCUMENT_DOCUMENT_CONTENT [fail]';
export const SIGN_DOCUMENT_LOAD_SIGNED_DOCUMENT_CONTENT =
    'page/SIGN_DOCUMENT_SIGNED_DOCUMENT_CONTENT [loading]';
export const SIGN_DOCUMENT_SHOW_SIGNED_DOCUMENT_CONTENT =
    'page/SIGN_DOCUMENT_SIGNED_DOCUMENT_CONTENT [done]';
export const SIGN_DOCUMENT_AGREE_AND_CONTINUE_ACTION =
    'page/SIGN_DOCUMENT_AGREE_AND_CONTINUE_ACTION';
export const SIGN_DOCUMENT_BOTTOM_VISIBLE = 'page/SIGN_DOCUMENT_BOTTOM_VISIBLE';

export const TOGGLE_DOCUMENT_CHECKBOX = 'page/TOGGLE_DOCUMENT_CHECKBOX';
